export default __webpack_public_path__ + "static/media/arrow-right-thin.d8ade43d.svg";